module.exports = __webpack_public_path__ + "img/alert-icon.f21d511a.svg";